import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import ModalContextProvider from './ModalContext'
import ModalContextButton from './ModalContextButton'

import '../../css/common/KeyList.css'

type TDeleteLinkProps = {
  disable: boolean
  title: string
  onDelete: () => void
  itemName: string
  showNoteSoftDelete: boolean
}

const TDeleteLink = ({
  disable,
  title,
  onDelete,
  itemName,
  showNoteSoftDelete,
}: TDeleteLinkProps) => {
  const { t } = useTranslation()
  const [change, setChange] = useState(false)

  const showWarning = () => (
    <p>
      <span className="responsive-font text-danger">
        <b>{t('warning')}</b>
      </span>{' '}
      {t('not_reversable')}
    </p>
  )

  const showCheckBox = () => (
    <label>
      <input
        className="responsive-checkbox"
        type="checkbox"
        onChange={() => setChange(!change)}
        title={t('check_box_to_delete')}
      />
      <span>
        {' '}
        {t('check_to_delete')} {itemName}
      </span>
    </label>
  )

  return (
    <ModalContextProvider
      title={title}
      body={
        showNoteSoftDelete ? (
          <>
            {showWarning()}
            <p>
              <small>{t('soft_delete_warning')}</small>
            </p>
            {showCheckBox()}
          </>
        ) : (
          <>
            {showWarning()}
            {showCheckBox()}
          </>
        )
      }
      buttonOk={t('delete')}
      buttonCancel={t('cancel')}
      buttonOkWarn={true}
      buttonOkDisabled={change ? false : true}
    >
      <ModalContextButton
        onOk={onDelete}
        disabled={disable}
        onCancel={() => setChange(false)}
      >
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          className={`bi bi-trash ${disable && 'svg-disabled'}`}
          fill="#FF0000"
          xmlns="http://www.w3.org/2000/svg"
          aria-labelledby="alt"
        >
          <title id="alt" lang="en">
            {disable ? t('no_delete_permission') : t('delete')}
          </title>
          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
          <path
            fillRule="evenodd"
            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
          />
        </svg>
      </ModalContextButton>
    </ModalContextProvider>
  )
}

export default TDeleteLink
